import React from 'react';
import { Dropdown, IDropdownOption, IDropdownStyles } from '@fluentui/react';
import { Car } from '../Model/Car';

interface CarSelectorProps {
    cars: Car[];
    selectedCarId: string;
    onCarSelect: (car: Car | null, carId: string) => void;
    dropdownStyles?: Partial<IDropdownStyles>;
}

const CarSelector: React.FC<CarSelectorProps> = ({
    cars,
    selectedCarId,
    onCarSelect,
    dropdownStyles,
}) => {
    const carOptions: IDropdownOption[] = cars.map((car) => ({
        key: car.licensePlate,
        text: `${car.carName} (${car.licensePlate})`,
        data: { carData: car },
    }));

    const handleChange = (_: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (!option) {
            onCarSelect(null, '');
            return;
        }

        const car: Car = option.data?.carData;
        onCarSelect(car, option.key.toString());
    };

    return (
        <Dropdown
            placeholder="Vyber auto"
            label="Auto"
            required
            options={carOptions}
            styles={dropdownStyles}
            selectedKey={selectedCarId}
            onChange={handleChange}
        />
    );
};

export default CarSelector;
